module.exports = __webpack_public_path__ + "img/Butterfly_00215.cb02c866.png";